import { Link } from 'react-router-dom';
import './Slide.css';

const Slide = ({ slide, isActive, flipped }) => {
    const activeClass = isActive ? ' slide--active' : '';
    const flippedClass = flipped ? ' slide--flipped' : '';

    return (
        <div className={`slide${flippedClass}${activeClass}`}>
            <div className="slide_content">
                <div className="slide_tag">
                    <div className="slide_tag-line" />
                    <span className="slide_tag-text">{slide.tag}</span>
                </div>

                <div>
                    <h2 className="slide_title">{slide.title}</h2>
                    <p className="slide_desc">{slide.description}</p>
                </div>

                <Link to={`/product/${slide.slug}`} className="slide_cta">
                    Explore
                    <svg className="slide_cta-arrow" viewBox="0 0 16 16" fill="none">
                        <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </Link>
            </div>

            <div className="slide_image">
                <img
                    className="slide_img"
                    src={slide.imageUrl}
                    alt={slide.imageAlt || slide.title}
                    loading="lazy"
                />
            </div>
        </div>
    );
};

export default Slide;
